module.exports = __webpack_public_path__ + "static/media/wp_tutorial_image_3.a5f30821.png";